export const mockPreactiveProperty = {
    id: 341172,
    expert: {
        forename: 'Anna',
        surname: 'Essex',
        imageUrl:
            'https://pbqastorage.blob.core.windows.net/agentfiles/clarehughes-desktop.jpg',
        phoneNumber: '0121 744 7556',
        agentId: 194,
    },
    address: '742 Evergreen Terrace',
    valuationId: 987654,
    hasValuation: false,
    initialBoardOrdered: false,
    bookExpertDate: '2019-03-10T10:30:00Z',
    bookingId: 634393,
    bookingIsConfirmed: true,
    instructDate: null,
    publishDate: null,
    scheduledMarketingDate: '2020-03-17T09:00:00Z',
    lastActionCompleted: 'BookValuation',
    toLet: false,
    shoppingCart: {
        id: 537959,
        vatRate: 20,
        vatTotal: 216.5,
        total: 1299,
        voucherDiscount: 0,
        itemCount: 3,
        items: [
            {
                itemId: 1560934,
                shoppingCartId: 537959,
                addOnId: null,
                description: null,
                value: 999,
                quantity: 1,
                zeroValueText: null,
                type: null,
                isVatExcluded: false,
            },
            {
                itemId: 1560935,
                shoppingCartId: 537959,
                addOnId: null,
                description: null,
                value: 0,
                quantity: 1,
                zeroValueText: null,
                type: null,
                isVatExcluded: false,
            },
            {
                itemId: 1625295,
                shoppingCartId: 537959,
                addOnId: null,
                description: null,
                value: 300,
                quantity: 1,
                zeroValueText: null,
                type: null,
                isVatExcluded: false,
            },
        ],
        voucher: null,
        payAtSettlementTotal: 0,
        payNowTotal: 1299,
        isInstruction: false,
    },
    propertiesCount: 4,
    approveListingCurrentStep: 0,
    isDiy: false,
    diyViewModel: null,
    regulatoryCertificateType: null,
    regulatoryCertificateIsOrdered: false,
    regulatoryCertificateIsBeingValidated: false,
    isSalesContractAvailable: false,
    pageToDisplay: null,
    propertyTimeZone: 'Europe/London',
    isInstantInstruct: false,
    comingSoon: false,
    isDeferred: false,
    marketingFee: 0,
    paymentMethod: null,
    paymentDateTime: null,
    hasOwnershipStatus: false,
    paymentSwitchAvailable: false,
    isScottishSaleProperty: false,
    homeReportExpiryDate: null,
    freePackageOrdered: true,
    orderedBcProductIds: [1],
    instantValuationConfidenceLevel: '',
    eventType: 'Valuation',
    customerCanUploadPhotos: true,
};
